import React from "react";
import "./DetailedServiceJourney.scss";
import backgroundImage from "../../../assets/img/service-journey-banner.jpg";

const ServiceJourney = ({ journey }) => {

    if (!journey) {
        return <div className="error">Journey data is not available</div>;
    }

  return (
    <div>
      <div className="service-jounrey-banner">
        <img src={backgroundImage} alt="banner background" className="banner-background" />
        <div className="banner-content">
          <h2 className="service-journey__title">How it Works</h2>
        </div>
      </div>

      <section className="service-journey">
        <div className="service-journey__steps">
          {journey.steps.map((step, index) => (
            <div className="journey-card" key={index}>
              <img
                src={require(`../../../assets/img/${step.src}`)}
                alt={step.alt}
                className="journey-card__image"
              />
              <div className="journey-card__content">
                <h3 className="journey-card__heading">{step.title}</h3>
                <p className="journey-card__description">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ServiceJourney;
